import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import bem from 'utils/bem';
import Popover from '@mui/material/Popover';
import Text from 'components/Text';
import './index.sass';

const { block, el } = bem('context-menu');
const ContextMenu = ({ anchorEl, open, onClose, openTransferForm, transferEnabled, canStartMeeting, orderId}) => {

    const classes = {
        paper: el('paper')
    };

    const ref = useRef();

    const clickHandler = () => {
        openTransferForm();
        onClose();
    }

    return (
        <div className={block()}>
            <Popover
                action={ref}
                open={open}
                onClose={onClose}
                classes={classes}
                anchorEl={anchorEl}
                anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
                transformOrigin={{vertical: 'top', horizontal: 'right'}}
            >
                <div className={el('menu')}>
                    <div className={ el('list') }>
                        { transferEnabled && <div className={ el('item') } onClick={ clickHandler }>
                            <Text>Перенести</Text>
                        </div> }
                        { canStartMeeting && <Link className={ el('item') } to={ `/orders/${orderId}/conference` }>
                            <Text>Начать консультацию</Text>
                        </Link> }
                    </div>
                </div>
            </Popover>
        </div>
    );
};

export default ContextMenu;



